import { useState } from 'react';

import {
  PLANNERS_TAXONOMY_KEY,
  VendorTaxonomyKey,
} from '@zola-helpers/client/dist/es/marketplace/vendorTaxonomyKeys';
import { SearchLocationView } from '@zola/svc-marketplace-ts-types';
import useEffectOnce from '@zola/zola-ui/src/hooks/useEffectOnce';
import { COLORS3 } from '@zola/zola-ui/src/styles/emotion';

import { PageSection } from '../../../PageSection/PageSection';
import { LowPlannerSupply } from './LowPlannerSupply';
import { LowSupplyCrossSell } from './LowSupplyCrossSell';

export interface LowSupplyNoticeProps {
  taxonomyKey?: VendorTaxonomyKey;
  location: SearchLocationView;
}

export const LowSupplyShelf = ({ taxonomyKey, location }: LowSupplyNoticeProps) => {
  const [isClient, setIsClient] = useState(false);

  useEffectOnce(() => {
    setIsClient(true);
  });

  if (!isClient) {
    return null;
  }

  if (taxonomyKey === PLANNERS_TAXONOMY_KEY && location.type === 'CITY') {
    return (
      <PageSection backgroundColor={COLORS3.CLOUD_100}>
        <LowPlannerSupply taxonomyKey={taxonomyKey} location={location} />
      </PageSection>
    );
  }

  return (
    <PageSection>
      <LowSupplyCrossSell taxonomyKey={taxonomyKey} />
    </PageSection>
  );
};
